import { render, staticRenderFns } from "./Compression_Materials.vue?vue&type=template&id=4b4d73ae&scoped=true"
import script from "./Compression_Materials.vue?vue&type=script&lang=js"
export * from "./Compression_Materials.vue?vue&type=script&lang=js"
import style0 from "./Compression_Materials.vue?vue&type=style&index=0&id=4b4d73ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d73ae",
  null
  
)

export default component.exports